import React from 'react';
import { motion } from 'framer-motion';
export function TransformationSection() {
  return <section className="w-full max-w-2xl mx-auto px-4 py-24" data-id="element-227">
      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="text-center space-y-8" data-id="element-228">
        <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-229">
          Lo que realmente compras
        </h2>

        <div className="space-y-6" data-id="element-230">
          <p className="text-xl md:text-2xl text-gray-300 leading-relaxed" data-id="element-231">
            No compras "un PDF". Compras algo más raro: <br data-id="element-232" />
            <span className="text-white font-bold bg-gradient-to-r from-[#25F4EE]/20 to-[#FE2C55]/20 px-2 rounded" data-id="element-233">
              una versión de ti que termina lo que empieza.
            </span>
          </p>

          <p className="text-xl md:text-2xl text-gray-300 leading-relaxed" data-id="element-234">
            Porque cuando por fin tienes un sistema… la parte de "emprender"
            deja de sentirse como fantasía y empieza a sentirse como rutina.
          </p>
        </div>
      </motion.div>
    </section>;
}